
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/design-system",
      function () {
        return require("private-next-pages/design-system/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/design-system"])
      });
    }
  